import React from 'react';
import BlockChart from '../../BlockChart';
import { useTranslation } from 'react-i18next';
import { useGetPublisherDevicesPerOsQuery } from '../../../api/publisherApiSlice';
import PieChart from '../../charts/PieChart'

export default function DeviceByOs ({publisherId, startDate, endDate}) {
	const { t } = useTranslation();
  const { data = [], isSuccess, isLoading } = useGetPublisherDevicesPerOsQuery({publisherId, startDate, endDate})
  const chartData = data.map((x)=>({"name":x.os,"y":x.active_devices}));

  return (
    <BlockChart title={t("publisher.deviceByOs")} isSuccess={isSuccess} isLoading={isLoading}>
      <PieChart data={chartData}/>
    </BlockChart>
  )
}
